
import api, { ApiError } from '@/api';
// import router from '@/router';
import _ from 'lodash';

const USERS_COLORS = [`#C0392B`, `#E74C3C`, `#9B59B6`, `#8E44AD`, `#2980B9`, `#3498DB`, `#1ABC9C`, `#16A085`, `#27AE60`, `#2ECC71`, `#F1C40F`, `#F39C12`, `#E67E22`, `#D35400`, `#34495E`];

const namespaced = true;

const state = {
  me: {},
  isAdmin: false,
  isMakerUser: false,
  isSelfMakerUser: false,
  isAggregatorUser: false,
  users: [],
  currentUser: {},
  currentUserRights: [],
  colors: USERS_COLORS,
};

const mutations = {
  SET_ME(state, me) {
    state.me = me || {};
    if (me && me.id) {
      state.me.email = _.trim(state.me.email || ``);
      state.isAdmin = me.clientAdmin;
      state.isAtLeastContributor = [`administrator`, `contributor`].includes(me.role);
      state.isMakerUser = me.client.isRoot;
      state.isSelfMakerUser = !state.isMakerUser && me.client.isSelfMaker;
      state.isAggregatorUser = !me.client.isRoot;
    }
  },
  SET_USERS(state, users) {
    state.users = users;
  },
  ADD_USER(state, user) {
    state.users.push(user);
  },
  SET_CURRENT_USER(state, user) {
    const userIndex = _.findIndex(state.users, { id: user.id });
    state.currentUser = user;
    if (userIndex !== -1) {
      state.users[userIndex] = state.currentUser;
      state.users = _.clone(state.users);
    }
  },
  SET_CURRENT_USER_RIGHTS(state, rights) {
    state.currentUserRights = rights;
  },
};

const actions = {
  async fetchMe({ commit, dispatch }) {
    let me = null;
    try {
      const res = await api.get(`/auth/me`);
      me = res.data;
    } catch (e) {} // eslint-disable-line

    if (me) {
      commit(`SET_ME`, me);
      if (me.spaces && me.spaces.length) {
        commit(`model/auth/SET_SPACES`, me.spaces, { root: true });
      } else {
        commit(`model/auth/SET_SPACES`, [], { root: true });
      }
      dispatch(`meFetched`, null, { root: true });
    }
  },
  async fetchForClient(noop, clientId) {
    const url = `/users${clientId ? `/client/${clientId}` : ``}`;
    const { data: users } = await api.get(url);

    return users;
  },
  logVisit({ state }) {
    if (state.me && state.me.id) {
      api.post(`/user-visits`);
    }
  },
  async fetchUsersForClient({ dispatch }, clientId) {
    const users = await dispatch(`fetchForClient`, clientId);

    return users;
  },
  async fetchUsers({ commit, rootState, dispatch }, clientId) {
    const users = await dispatch(`fetchForClient`, clientId);
    commit(`SET_USERS`, users);
    if (!clientId && rootState[`model/client`].company.id) {
      commit(`model/client/SET_COMPANY`, {
        ...rootState[`model/client`].company,
        nbUsers: users.length,
      }, { root: true });
    }
  },
  async addUser({ commit }, user) {
    try {
      const { data: newUser } = await api.post(`/users`, user);
      commit(`ADD_USER`, newUser);
      return newUser;
    } catch (e) {
      if (e?.response?.status === 400) {
        const error = e.response.data?.error || `UNKNOWN`;
        throw new ApiError(error);
      }
      return null;
    }
  },
  async addMakerUserByEmail(store, { email, makerId }) {
    const { data: user } = await api.post(`/users/maker/${makerId}/by-email`, { email });

    return user;
  },
  setCurrentUser({ commit }, user) {
    commit(`SET_CURRENT_USER`, user);
  },
  async saveCurrentUser({ state, commit }) {
    try {
      const { data: user } = await api.put(`/users/${state.currentUser.id}`, state.currentUser);
      commit(`SET_CURRENT_USER`, user);
    } catch (e) { } // eslint-disable-line
  },
  async saveUser(store, user) {
    let savedUser = null;
    try {
      const { data } = await api.put(`/users/${user.id}`, user);
      savedUser = data;
    } catch (e) { } // eslint-disable-line
    return savedUser;
  },
  async fetchCurrentUserRights({ state, commit }) {
    const user = state.currentUser;
    const { data: rights } = await api.get(`/users/${user.id}/rights`);
    commit(`SET_CURRENT_USER_RIGHTS`, rights);
  },
  async saveUserRights({ state }, rights) {
    try {
      await Promise.all(rights.map(right =>
        api.put(`/users/${state.currentUser.id}/rights/maker/${right.maker.id}`, right)
      ));
    } catch (e) { } // eslint-disable-line
  },
  async saveMe({ commit }, me) {
    try {
      await api.put(`/users/me`, me);
      commit(`SET_ME`, me);
    } catch (e) { } // eslint-disable-line
  },
  async savePassword(store, passwords) {
    const res = {
      success: true,
      data: ``,
    };
    try {
      await api.put(`/users/me/password`, passwords);
    } catch (e) {
      res.success = false;
      res.data = e.response.data;
    }

    return res;
  },
  async saveCurrentUserPassword({ state }, password) {
    try {
      await api.put(`/users/${state.currentUser.id}/password`, password);
    } catch (e) {} // eslint-disable-line
  },
  async resendInvitation(store, user) {
    try {
      await api.post(`/users/${user.id}/send-invitation`);
    } catch (e) {} // eslint-disable-line
  },
};

const getters = {
  isIndeegoUser(state) {
    return Boolean(state.me?.isIndeego);
  },
  spaces: state => state.me?.spaces || [],
  hasMultipleSpaces: (state, getters) => getters.spaces.length > 1,
  // hasMultipleSpaces: () => true,
};

export default {
  namespaced, state, mutations, actions, getters,
};
